/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Seats_Remaining_OneInputs */



/**
* | output |
* | --- |
* | "1 seat remaining" |
*
* @param {Members_Seats_Remaining_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_seats_remaining_one = /** @type {((inputs?: Members_Seats_Remaining_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Seats_Remaining_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Platz verbleibend")
	return /** @type {LocalizedString} */ ("1 seat remaining")
});